import { ScrollReveal } from "@/hooks/useScrollReveal";
import Watermark from "@/components/base/Watermark";

export default function PublishingPhilosophy() {
  const steps = [
    { num: "01", title: "主題與讀者定位", desc: "確認每本書的核心主題、知識範圍與目標讀者，確保內容聚焦且具針對性。" },
    { num: "02", title: "內容結構整理", desc: "將研究素材系統化地整理為章節結構，建立清晰的閱讀路徑與知識層次。" },
    { num: "03", title: "專業概念轉譯", desc: "協助作者將專業術語與複雜概念，轉化為一般讀者可以理解的表達方式。" },
    { num: "04", title: "編輯與版面呈現", desc: "透過專業編輯與版面設計，提升內容的可讀性與視覺層次，讓閱讀更舒適。" },
    { num: "05", title: "正式出版", desc: "完成審查、校對、設計與印製流程，將作品以紙本與電子書形式正式出版。" },
    { num: "06", title: "長期書目與閱讀導流", desc: "出版後持續提供閱讀導引、主題書單與相關推薦，讓書籍成為讀者的長期知識資源。" },
  ];

  return (
    <section className="min-h-[100svh] flex items-center bg-background-50">
      <Watermark />
      <div className="mx-auto px-6 md:px-10 py-16 md:py-24 max-w-[1120px] w-full">
        <ScrollReveal>
          <div className="flex flex-col lg:flex-row lg:gap-16 mb-14 md:mb-20">
            <div className="lg:w-[30%] flex-shrink-0 mb-6 lg:mb-0">
              <p className="text-xs tracking-[0.2em] uppercase text-foreground-400 font-medium">
                Philosophy
              </p>
            </div>
            <div className="lg:w-[70%]">
              <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 leading-tight">
                一本專業書，如何變得清楚可讀
              </h2>
              <p className="text-sm text-foreground-500 mt-4 leading-relaxed max-w-lg">
                這是崧燁文化事業有限公司的出版理念流程，說明我們如何將專業知識整理成可持續閱讀的出版內容
              </p>
            </div>
          </div>
        </ScrollReveal>

        <div className="lg:ml-[30%] lg:pl-16">
          <div className="max-w-lg">
            {steps.map((step, i) => (
              <ScrollReveal key={step.num} delay={i * 80}>
                <div className="flex gap-5">
                  <div className="flex flex-col items-center flex-shrink-0">
                    <div className="w-9 h-9 flex items-center justify-center font-heading text-sm font-bold text-primary-700 bg-primary-100">
                      {step.num}
                    </div>
                    {i < steps.length - 1 && (
                      <div className="w-px flex-1 bg-background-300 my-1.5"></div>
                    )}
                  </div>
                  <div className={`pb-10 ${i === steps.length - 1 ? "pb-0" : ""}`}>
                    <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mb-1.5">
                      {step.title}
                    </h3>
                    <p className="text-sm text-foreground-600 leading-relaxed">
                      {step.desc}
                    </p>
                  </div>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal delay={500}>
            <p className="text-xs text-foreground-400 mt-8 max-w-lg leading-relaxed">
              此流程說明崧燁文化事業有限公司的品牌出版理念，不代表每本書都經過所有環節，實際出版流程依作品屬性與合作方式調整。
            </p>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}